export const SALES_MODULE_KEY = 'sales';
export const PURCHASE_MODULE_KEY = 'purchases';
export const DOCUMENT_REPORT_MODULE_KEY = 'document_report';
export const VAT_REPORT_MODULE_KEY = 'vat_report';
export const BULK_UPLOAD_MODULE_KEY = 'bulk_upload';
export const BUSINESS_PROFILES_MODULE_KEY = 'business_profiles';
export const DEVELOPER_DASHBOARD_MODULE_KEY = 'developer_dashboard';

export const EINVOICING_MODULE_KEYS = [
  SALES_MODULE_KEY,
  PURCHASE_MODULE_KEY,
  DOCUMENT_REPORT_MODULE_KEY,
  VAT_REPORT_MODULE_KEY,
  BULK_UPLOAD_MODULE_KEY,
];

export const ROLE_MODULES = [
  { key: SALES_MODULE_KEY, infoTooltip: true },
  { key: PURCHASE_MODULE_KEY, infoTooltip: true },
  { key: DOCUMENT_REPORT_MODULE_KEY, infoTooltip: true },
  { key: VAT_REPORT_MODULE_KEY, infoTooltip: true },
  { key: DEVELOPER_DASHBOARD_MODULE_KEY, infoTooltip: true },
  { key: BULK_UPLOAD_MODULE_KEY, infoTooltip: true },
];

export const ACCESS_LEVELS = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
};

export const ACCESS_LEVEL_OPTIONS = [
  { value: ACCESS_LEVELS.NONE, labelKey: 'none' },
  { value: ACCESS_LEVELS.READ, labelKey: 'read_only' },
  { value: ACCESS_LEVELS.WRITE, labelKey: 'read_write' },
];

export const BUSINESS_PROFILE_ACCESS_LEVEL_OPTIONS = [
  { value: ACCESS_LEVELS.READ, labelKey: 'read_only' },
  { value: ACCESS_LEVELS.WRITE, labelKey: 'read_write' },
];

export const buildDefaultPermissions = () => ({
  [SALES_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [PURCHASE_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [DOCUMENT_REPORT_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [VAT_REPORT_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [DEVELOPER_DASHBOARD_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [BULK_UPLOAD_MODULE_KEY]: ACCESS_LEVELS.NONE,
  [BUSINESS_PROFILES_MODULE_KEY]: ACCESS_LEVELS.READ,
});

export const permissionsToMap = (permissions = {}) => {
  const map = buildDefaultPermissions();
  if (permissions && typeof permissions === 'object') {
    ROLE_MODULES.forEach(({ key }) => {
      if (permissions[key] !== undefined && permissions[key] !== null) {
        map[key] = permissions[key];
      }
    });
    if (permissions[BUSINESS_PROFILES_MODULE_KEY]) {
      map[BUSINESS_PROFILES_MODULE_KEY] = permissions[BUSINESS_PROFILES_MODULE_KEY];
    }
  }
  return map;
};

export const mapToPermissionsPayload = (accessMap) => {
  const payload = {};
  ROLE_MODULES.forEach(({ key }) => {
    payload[key] = accessMap[key] ?? ACCESS_LEVELS.NONE;
  });
  payload[BUSINESS_PROFILES_MODULE_KEY] = accessMap[BUSINESS_PROFILES_MODULE_KEY] ?? ACCESS_LEVELS.NONE;
  return payload;
};

export const isEinvoicingModuleActive = (permissionMap = {}) =>
  EINVOICING_MODULE_KEYS.some((key) => (permissionMap[key] ?? ACCESS_LEVELS.NONE) > ACCESS_LEVELS.NONE);

export const applyDeveloperDashboardSelection = (permissionMap, level) => {
  const next = { ...permissionMap, [DEVELOPER_DASHBOARD_MODULE_KEY]: level };
  if (level > ACCESS_LEVELS.NONE) {
    EINVOICING_MODULE_KEYS.forEach((key) => {
      next[key] = ACCESS_LEVELS.NONE;
    });
    next[BUSINESS_PROFILES_MODULE_KEY] = ACCESS_LEVELS.READ;
  }
  return next;
};

export const applyEinvoicingModuleSelection = (permissionMap, moduleKey, level) => ({
  ...permissionMap,
  [moduleKey]: level,
  [DEVELOPER_DASHBOARD_MODULE_KEY]: ACCESS_LEVELS.NONE,
});
